import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/about/line_shopping.png')
const LOGO = assets.images.logo.lineShopping

const LineShoppingLogo = (props: ICommonLogoOptionalProps) => <CommonLogo source={LOGO} {...props} />

export default LineShoppingLogo
